import { featureFlags } from "@/config/features";

type SocialProofProps = {
  onSignIn: () => void;
};

export function SocialProof({ onSignIn }: SocialProofProps) {
  return (
    <>
      <p className="text-center text-gray-500 text-xs">
        By continuing, you agree to our{" "}
        <a className="font-medium text-gold-accent transition-opacity hover:opacity-80" href="/terms">
          Terms of Service
        </a>{" "}
        and{" "}
        <a
          className="font-medium text-gold-accent transition-opacity hover:opacity-80"
          href="/privacy"
        >
          Privacy Policy
        </a>
      </p>

      <p className="text-center text-gray-500 text-sm">
        Already have an account?{" "}
        <button
          className="font-medium text-gold-accent transition-opacity hover:opacity-80"
          onClick={onSignIn}
          type="button"
        >
          Sign in
        </button>
      </p>

      {/* Trust indicators */}
      <div className="flex items-center justify-center gap-4 text-gray-400 text-xs">
        <span>{featureFlags.enablePaidGate ? "3-day free trial" : "No credit card required"}</span>
      </div>
    </>
  );
}
